import * as S from './styled'
import WhatsAppDisclaimer from './components/WhatsAppDisclaimer'

const HeaderDisclaimer = () => (
    <S.Wrapper
      href="https://api.whatsapp.com/send?phone=551140071380&text=Ol%C3%A1,+desejo+comprar+um+produto"
      rel="noopener noreferrer"
      target="_blank"
    >
      <WhatsAppDisclaimer />
    </S.Wrapper>
)

export default HeaderDisclaimer
